<div class="schedule-page">
  <header class="schedule-header">
    <div>
      <h1>Bookings</h1>
      <p>Plan bookings and court availability</p>
    </div>
    <div class="schedule-actions">
      <button
        *ngIf="canManageUnavailability"
        mat-stroked-button
        (click)="openUnavailabilityDialog()"
        [disabled]="!selectedBooking.venueId || !courts.length"
      >
        Block court
      </button>
      <button
        *ngIf="canCreateBooking"
        mat-flat-button
        color="primary"
        (click)="openDialog(selectedBooking)"
      >
        + Add booking
      </button>
    </div>
  </header>
  <div class="schedule-filters">
    <mat-form-field subscriptSizing="dynamic"
      ><mat-label>Venue</mat-label>
      <mat-select
        [(value)]="selectedBooking.venueId"
        (selectionChange)="fetchCourts($event)"
      >
        <mat-option *ngFor="let venue of venues" [value]="venue._id">{{
          venue.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic"
      ><mat-label>Court</mat-label>
      <mat-select
        [(value)]="selectedBooking.courtId"
        (selectionChange)="selectCourt($event)"
      >
        <mat-option value="">All courts</mat-option>
        <mat-option *ngFor="let court of courts" [value]="court._id">{{
          court.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <label class="date-control"
      >Go to date<input
        type="date"
        aria-label="Go to date"
        [value]="visibleDate"
        (change)="jumpToDate($any($event.target).value)"
    /></label>
    <div class="view-switch" role="group" aria-label="Calendar view">
      <button
        (click)="setView('dayGridMonth')"
        [class.active]="
          !courtDay && calendar?.getApi()?.view?.type === 'dayGridMonth'
        "
      >
        Month
      </button>
      <button
        (click)="setView('timeGridWeek')"
        [class.active]="
          !courtDay && calendar?.getApi()?.view?.type === 'timeGridWeek'
        "
      >
        Week
      </button>
      <button (click)="setView('courts')" [class.active]="courtDay">
        Day by court
      </button>
    </div>
  </div>
  <section class="schedule-card" aria-label="Booking calendar">
    <div class="schedule-key">
      <span>Times: {{ venueTimezone }}</span>
      <div>
        <span class="key football">Football</span
        ><span class="key basketball">Basketball</span
        ><span class="key padel">Padel</span
        ><span class="key maintenance">Maintenance / blocked</span>
      </div>
    </div>
    <full-calendar
      [class.court-toolbar]="courtDay"
      [options]="calendarOptions"
    ></full-calendar>
    <app-court-day
      *ngIf="courtDay"
      [courts]="visibleCourts"
      [events]="calendarEvents"
      [date]="visibleDate"
      [options]="calendarOptions"
    />
    <p class="schedule-hint">
      {{
        courtDay
          ? "Each column is a court. Select an available time to book."
          : "Select a court to focus the schedule. Click a booking for details."
      }}
    </p>
  </section>
</div>
